import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui ning standart klass birlashtiruvchisi — registrdan olingan komponentlar shuni kutadi. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Raqamlarni mingliklar bo'yicha bo'shliq bilan yozish — Mini App dagi `formatNumber` bilan bir
 * xil qoida (`apps/front/src/i18n/format.ts`). Ball narxi 19 millionga yetishi mumkin, ya'ni
 * ajratuvchisiz raqam operator uchun bir zumda o'qib bo'lmaydigan qatorga aylanadi.
 *
 * Ajratuvchi — UZILMAYDIGAN bo'shliq (U+00A0), oddiy bo'shliq emas.
 *
 * Farqi tor ustunda ko'rinadi: oddiy bo'shliqda brauzer "128 400" ni ikki qatorga bo'lib
 * yuboradi va ustunda "128" ustida "400" turadi — ya'ni ajratuvchi raqamni o'qilishi uchun
 * qo'yilgan bo'lsa-da, aynan o'qishni buzadi. Ekranda ikkalasi bir xil ko'rinadi.
 */
const GROUP_SEPARATOR = '\u00a0';

export function formatNumber(value: number): string {
  const negative = value < 0;
  const digits = Math.trunc(Math.abs(value)).toString();
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, GROUP_SEPARATOR);
  return negative ? `-${grouped}` : grouped;
}
